import { eventBus } from '../event-manager';
import JitsiMeetJS from '../lib-jitsi-meet';
import { useConfigStore } from '../store';
import { useConnectionStore } from '../store/connection';
import { INTERNAL_EVENTS } from '../utils';
import { createConference } from './conference';

export async function connect(autoJoinConference = true) {
  const existingConnection = useConnectionStore.getState().connection;
  if (existingConnection) {
    createConference();
    return;
  }

  const options = useConnectionStore.getState().connectionConfig;
  const jwt = useConnectionStore.getState().jwt;
  const iAmRecorder = useConfigStore.getState().iAmRecorder;

  if (options && iAmRecorder) {
    options.p2p = {
      enabled: false,
    };
  }

  const connection = new JitsiMeetJS.JitsiConnection(null, jwt, options);

  useConnectionStore.getState().connectionWillConnect(connection);

  connection.addEventListener(
    JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED,
    onConnectionEstablished,
  );
  connection.addEventListener(
    JitsiMeetJS.events.connection.CONNECTION_FAILED,
    onConnectionFailed,
  );
  connection.addEventListener(
    JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED,
    onDisconnected,
  );
  connection.addEventListener(
    JitsiMeetJS.events.connection.PROPERTIES_UPDATED,
    onPropertiesUpdated,
  );

  async function onConnectionEstablished() {
    useConnectionStore.getState().connectionEstablished(connection);
    eventBus.publish({
      type: INTERNAL_EVENTS.onConnectionEstablished,
    });
    if (!autoJoinConference) return;
    createConference();
  }

  function onConnectionFailed(err: string, message: string, ...args: any[]) {
    unsubscribe();
    console.error('Connection failed', err, message, args);
    // err === 'connection.passwordRequired'
    // err === 'connection.otherError'

    // TODO: handle args options properly
    // const todoArgs = [
    //   'connection.otherError',
    //   'The WebSocket connection could not be established or was disconnected.',
    //   null,
    //   {
    //     suspend_time: 22147,
    //     time_since_last_success: 51900,
    //   },
    // ];
    useConnectionStore.getState().connectionFailed(message);
    // reconnectSession();
    // leaveSession();
  }

  function onDisconnected() {}

  function onPropertiesUpdated(properties: any) {
    // TODO: check if this is needed
    console.log('Properties updated', properties);
  }

  function unsubscribe() {
    connection.removeEventListener(
      JitsiMeetJS.events.connection.PROPERTIES_UPDATED,
      onPropertiesUpdated,
    );
    connection.removeEventListener(
      JitsiMeetJS.events.connection.CONNECTION_FAILED,
      onConnectionFailed,
    );
    connection.removeEventListener(
      JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED,
      onDisconnected,
    );
  }

  const xmpp_username_override = localStorage.getItem('xmpp_username_override');
  const xmpp_password_override = localStorage.getItem('xmpp_password_override');

  if (xmpp_username_override && xmpp_password_override) {
    connection.addFeature('http://jitsi.org/protocol/jibri');
    connection.connect({
      id: xmpp_username_override,
      password: xmpp_password_override,
    });
  } else {
    connection.connect();
  }
}
